import { CURRENCY_SIGN } from "@utils/constants";
import { commaNumber } from "@utils/numberHelper";
import React from "react";

const PriceComponent = ({ price, sales_price, className, isReversed }) => {
  const returnPrice = (
    <span
      className={`text-[13px] ${
        !isReversed ? "mr-1" : "ml-1"
      } font-semibold text-gray-500 line-through`}
    >
      {CURRENCY_SIGN}
      {commaNumber(price)}
    </span>
  );

  return (
    <div className='text-right'>
      {price - sales_price > 0 ? (
        <div className={className || "mt-2"}>
          {!isReversed && returnPrice}{" "}
          <span className='text-lg font-semibold text-primary'>
            {CURRENCY_SIGN}
            {commaNumber(sales_price)}
          </span>{" "}
          {isReversed && returnPrice}
        </div>
      ) : (
        <div className='text-lg font-semibold text-primary'>
          {CURRENCY_SIGN}
          {commaNumber(sales_price)}
        </div>
      )}
    </div>
  );
};

export default PriceComponent;
